import { Box, MenuItem, Paper, Typography } from "@mui/material";
import { CustomBreadcrumbs } from "./CustomBreadcrumbs";
import MenuLink from "./Menu/MenuLink";
import { useLocation, useNavigate } from "react-router-dom";
import { customValue } from "../../utils/colorVariable";
import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { setApprovedDelivery } from "../../redux/stock/approvedDeliverySlice";
import { setTabUrl, setWarehouseUrl } from "../../utils/urlStorage";
import { CanAccessFunctionality } from "./Privilege/FunctionPrivilegeCheck";

interface ISubMenu {
  list: {
    link: string;
    label: string;
    user_functionalities?: Array<string>;
    subMenu?: { label: string; link: string }[];
  }[];
}

export function SubMenu({ list }: ISubMenu) {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const onNavigate = useCallback(
    (link: string) => () => {
      const url = link.split("/").at(-1) ?? "";
      if (url === "yarn" || url === "accessory") {
        setWarehouseUrl(url);
      }
      setTabUrl(url);
      navigate(link);
      // clear highlight in stock
      dispatch(setApprovedDelivery([]));
    },
    [navigate, dispatch]
  );

  const filteredList = list.filter(item =>
    !item.user_functionalities?.length ||
    CanAccessFunctionality({ user_functionalities: item.user_functionalities })
  );

  return (
    <Box component={Paper} p={1} borderRadius={customValue.borderRadius}>
      <Box
        display={"flex"}
        sx={{ justifyContent: { xs: "space-between" } }}
        mx={1}
      >
        <Box display="flex" gap={1}>
          {filteredList.length === 1 ? (
            <Typography variant="body1" color="initial">
              {filteredList[0].label}
            </Typography>
          ) : (
            filteredList.map((item, key) =>
              item.subMenu ? (
                <MenuLink
                  key={key}
                  label={item.label}
                  link={item.link}
                  hasDropdown={true}
                  isActive={location.pathname === item.link}
                  display={"flex"}
                  alignItems={"center"}
                  justifyContent={"center"}
                >
                  {item?.subMenu?.map((child, index) => (
                    <MenuItem key={index}>{child.label}</MenuItem>
                  ))}
                </MenuLink>
              ) : (
                <Box
                  key={key}
                  className={
                    item.link === window.location.pathname ? "active" : ""
                  }
                  onClick={onNavigate(item.link)}
                  color="inherit"
                  sx={{
                    fontSize: "16px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    paddingRight: "0px",
                    position: "relative",
                    textTransform: "inherit",
                    cursor: "pointer",
                    ":hover": {
                      "&:after": {
                        content: '""',
                        position: "absolute",
                        bottom: "6px",
                        left: "1%",
                        width: "100%",
                        height: "2px",
                        opacity: 0.2,
                        backgroundColor: "#333333",
                      },
                    },
                    "&.active::after": {
                      content: '""',
                      position: "absolute",
                      bottom: "6px",
                      left: "1%",
                      width: "100%",
                      height: "2px",
                      opacity: 0.2,
                      backgroundColor: "#000",
                    },
                  }}
                >
                  <Typography variant="body1" color="initial">
                    {item.label}
                  </Typography>
                </Box>
              )
            )
          )}
        </Box>
        <CustomBreadcrumbs />
      </Box>
    </Box>
  );
}
